import React from "react";
import { Dropdown, DropdownButton, InputGroup } from 'react-bootstrap';
import style from "./style.module.css"

const InputWSelect2 = props => {

  const { options, selected, setOption } = props;
  return (
    <div className={style.container}>
      <div className={style.options}>
        <DropdownButton
          as={InputGroup.Prepend}
          title={options?.find(__option => __option.value === selected)?.label || ""}
        >
          {options?.map(__option => (
            <Dropdown.Item
              onClick={() => {
                setOption(__option.value);
              }}
            >
              {__option.label}
            </Dropdown.Item>
          ))}

        </DropdownButton>
      </div>
      <div className={style.input}>
        {options?.find(__option => __option.value === selected)?.input}
      </div>
    </div>
  )
}

export default InputWSelect2;